export const workHoursEn = {
    errors: {
        notEnabled: 'Work hours are not set up for this organization.',
        accountNotFound: 'Work hours account not found.',
        entryNotFound: 'Entry not found.',
        ruleNotFound: 'Choose a rule from the work hours settings.',
        ruleInUse: 'Rules with accounts cannot be removed. Deactivate them instead.',
        groupTypeRequired: 'Choose the group type of the groups that owe the work.',
        accountRequired: 'Choose a revenue account for fees and buyouts.',
        chartAccountNotFound: 'Account {{account}} does not exist in the chart of accounts.',
        costCenterRequired: 'Choose cost center 1. The chart of accounts uses regions, so every receipt needs it.',
        invalidCostCenter: "Choose a bookable cost center of one of the organization's mandates.",
        accountSettled: 'This account is settled. Revoke the settlement first.',
        notEditable: 'This entry can no longer be changed.',
        dateOutsidePeriod: 'The date must lie within the period {{period}}.',
        dateInFuture: 'Work cannot be entered for future dates.',
        wholeShifts: 'Shifts are counted in whole numbers.',
        helperRequired: 'Choose who did the work.',
        helperNotAllowed: 'Only the contacts of this account may do the work.',
        notAllowed: 'You cannot enter work for this account.',
        ownEntry:
            'You cannot approve work that counts for your own or your family’s account. Another reviewer has to do it.',
        returnMessageRequired: 'Tell the member what needs to be changed.',
        tooMany: 'Select at most {{count}} at once.',
        payerRequired: 'Choose who pays for this account.',
        payerWithoutDebtor: '{{name}} has no debtor account yet, so no receipt can be created.',
        mandateRequired: 'Choose the mandate to book fees and buyouts in.',
        directDebitCashAccountRequired: 'Choose the bank account collecting the direct debits.',
        defaultMandateNotFound: 'Choose one of the mandates of the organization.',
        revokeNotPossible: 'The receipt was already paid, so the settlement can no longer be revoked.',
        buyoutNotAvailable: 'A buyout is not available for this account.',
        buyoutExpired: 'The buyout could only be chosen until {{date}}.',
        buyoutChosen: 'The buyout was already chosen for this account.',
        suggestionUsed: 'This work assignment was already entered.',
        holderDeleted: 'The holder of this account was deleted.',
        deadlinePassed: 'Work could only be entered until {{date}}.',
        deadlineRunning: 'Accounts can be settled once members can no longer enter work, after {{date}}.',
        entriesToReview: 'Entries of this account still wait for review. Review them first.',
        cashAccountNotFound: 'Choose a bank account of the organization that can be used in the booking mandate.',
        periodStartLocked:
            'The period start can no longer change, as accounts overlapping the new period already have work, notes or changes, or still need to be settled.',
        ruleLocked:
            'Who owes the work and its unit can no longer change, as accounts of the running period already have work, notes or changes. Deactivate the rule and add a new one instead.',
        approvalFailed: 'The entry could not be approved.',
        settlementFailed: 'The account could not be settled.',
    },
    quantity: {
        hours_one: '{{value}} hour',
        hours_other: '{{value}} hours',
        shifts_one: '{{value}} shift',
        shifts_other: '{{value}} shifts',
    },
    notifications: {
        open: 'Open account',
        review: 'Review entry',
        showAccounts: 'Show work hours',
        submittedTitle: 'Work hours to review',
        submittedMessage: '{{helper}} entered {{quantity}} for {{rule}} ({{name}}).',
        submittedOnBehalfMessage: '{{submitter}} entered {{quantity}} of {{helper}} for {{rule}} ({{name}}).',
        returnedTitle: 'Your work hours were returned',
        returnedMessage: '{{activity}} on {{date}}: {{message}}',
        approvedTitle: 'Work hours approved',
        approvedMessage: '{{quantity}} for {{rule}} counted. {{approved}} of {{required}} done.',
        revokedTitle: 'Work hours no longer approved',
        revokedMessage: '{{activity}} on {{date}} no longer counts for {{rule}}.',
        reminderTitle: '{{missing}} still open for {{rule}}',
        reminderMessage: 'Enter your work by {{deadline}}, otherwise missing work is charged.',
        reminderMessageWithoutFee: 'Enter your work by {{deadline}}.',
        settledTitle: '{{rule}} {{period}} settled',
        settledMessage: '{{missing}} missing, {{amount}} charged.',
        settledFulfilledMessage: 'All work done. Thank you!',
        settledWithoutFeeMessage: '{{missing}} missing.',
        buyoutTitle: 'Buyout for {{rule}} confirmed',
        buyoutMessage: '{{amount}} is charged instead of working in {{period}}.',
        deadlineSummaryTitle: 'Work hours deadline {{period}}',
        deadlineSummaryMessage_one: '{{count}} entry still waits for your review before the accounts can be settled.',
        deadlineSummaryMessage_other:
            '{{count}} entries still wait for your review before the accounts can be settled.',
    },
    properties: {
        groupName: 'Work hours account',
        holder: 'Owed by',
        groupNumber: 'Group number',
        rule: 'Rule',
        unit: 'Unit',
        units: {
            hours: 'Hours',
            shifts: 'Shifts',
        },
        period: 'Period',
        payer: 'Payer',
        months: 'Months owed',
        calculatedRequired: 'Calculated',
        overrideReason: 'Reason for adjustment',
        required: 'Required',
        approved: 'Approved',
        submitted: 'To review',
        missing: 'Missing',
        deadlineAt: 'Enter by',
        status: 'Status',
        statuses: {
            open: 'Open',
            settled: 'Settled',
        },
        fee: 'Fee per missing unit',
        boughtOutAt: 'Bought out at',
        settledAt: 'Settled at',
        settledAmount: 'Charged',
        reviewers: 'Reviewers',
        receiptNumber: 'Receipt',
    },
    entryProperties: {
        groupName: 'Work hours entry',
        date: 'Date',
        activity: 'Work',
        helper: 'Done by',
        quantity: 'Amount',
        status: 'Status',
        statuses: {
            draft: 'Returned',
            submitted: 'To review',
            approved: 'Approved',
        },
        event: 'Work assignment',
        submittedAt: 'Submitted at',
        submittedBy: 'Submitted by',
        submittedOnBehalf: 'Entered by staff',
        approvedAt: 'Approved at',
        approvedBy: 'Approved by',
    },
    export: {
        accountsFileName: 'Work hours accounts',
        entriesFileName: 'Work hours entries',
    },
    receipt: {
        feePosition: 'Fee for missing work – {{rule}} {{period}}',
        feeDescription: '{{missing}} × {{fee}}',
        buyoutPosition: 'Work hours buyout – {{rule}} {{period}}',
        buyoutDescription: '{{holder}}',
    },
}
